import styles from './FormSubHeader.module.css'

const FormSubHeader =  () => {
 return <span className={styles.formSubHeader}>For unconnected displays</span> 
}

export default FormSubHeader